import React from 'react';
import * as PropTypes from 'prop-types';
import { connect } from 'react-redux';
import './index.css';
import { Button, Dialog, DialogContent, IconButton } from '@material-ui/core';
import {
    deleteAsset,
    hidePreviewDialog,
    setActiveStep,
    hideUploadFilesDialog,
    setAssetUpload,
    setBulkMint,
} from '../../../../actions/createAssets';
import VideoPlayer from './VideoPlayer';
import withRouter from '../../../../components/WithRouter';
import { fetchAssets, setLibraryTabValue } from '../../../../actions/library';
import { getAssetType } from '../../../../utils/strings';
import ImageOnLoad from '../../../../components/ImageOnLoad';
import { mediaReference } from '../../../../utils/ipfs';
import { DEFAULT_LIMIT, DEFAULT_SKIP, TRANSACTION_SET_TIME_OUT } from '../../../../config';
import { Tooltip } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import DeleteIcon from '@mui/icons-material/DeleteOutlineOutlined';
import EditIcon from '@mui/icons-material/Edit';

const PreviewDialog = (props) => {
    const mediaNodeURL = props.mediaNodeDetails?.url;

    const url = props.value?.type === 'video' && props.value?.file?.encode?.path
        ? `${mediaNodeURL}/play${props.value?.file?.encode?.path}`
        : props.value && props.value.file && props.value.file.IPFS_hash
            ? mediaReference(props.value.file.IPFS_hash)
            : props.value && props.value.media_uri
                ? props.value.media_uri
                : props.value && props.value.metadata && props.value.metadata.media_uri
                    ? props.value.metadata.media_uri
                    : null;

    const poster = props.value && props.value.preview_cloudflare_cdn
        ? props.value.preview_cloudflare_cdn.variants && props.value.preview_cloudflare_cdn.variants[0]
        : props.value && props.value.cloudflare_cdn
            ? props.value.cloudflare_cdn.thumbnail
            : props.value && props.value.file && props.value.file['preview_IPFS_hash']
                ? props.value.file['preview_IPFS_hash']
                : props.value && props.value.preview_uri
                    ? props.value.preview_uri
                    : props.value && props.value.metadata && props.value.metadata.preview_uri
                        ? props.value.metadata.preview_uri
                        : null;

    const cdn = props.value && props.value.cloudflare_cdn && props.value.cloudflare_cdn.variants
        ? props.value.cloudflare_cdn.variants : null;

    const name = props.value && props.value.name
        ? props.value.name
        : props.value && props.value.metadata && props.value.metadata.name
            ? props.value.metadata.name
            : null;

    const handleEdit = () => {
        if (props.value && props.value._id && props.value.file && props.value.file['MIME_type']) {
            props.setActiveStep(0);
            props.setBulkMint(true);
            props.fetch(props.value._id);
            props.router.navigate('/library');
            props.setLibraryTabValue('non-minted');
            props.handleClose();
            props.hideUploadFilesDialog() && props.setAssetUpload(null, []);
        }
    };

    const handleDelete = () => {
        if (props.value && props.value._id) {
            props.deleteAsset(props.value._id, (error) => {
                if (!error) {
                    props.fetch(DEFAULT_SKIP, DEFAULT_LIMIT, (result, count) => {
                        if (props.assetsTotal === count) {
                            setTimeout(() => {
                                props.fetch(DEFAULT_SKIP, DEFAULT_LIMIT);
                            }, TRANSACTION_SET_TIME_OUT);
                        }
                    });
                }
            });
            props.handleClose();
        }
    };

    const type = (props.value?.file?.MIME_type && getAssetType(props.value.file.MIME_type)) ||
    (props.value?.media_type && getAssetType(props.value.media_type)) ||
    (props.value?.file?.encode?.path?.includes('.m3u8') ? 'video' : null);

    return (
        <Dialog
            aria-describedby="preview-dialog-description"
            aria-labelledby="preview-dialog-title"
            className="dialog preview_dialog"
            open={props.open}
            onClose={props.handleClose}>
            <DialogContent className="dialog_content">
                <div className="header">
                    <Tooltip title={name}>
                        <h2>{name}</h2>
                    </Tooltip>
                    <div className="actions">
                        {props.from === 'mediaNode'
                            ? null
                            : props.value && props.value._id && !props.value.id &&
                            props.value.file &&
                            <>
                                <Button onClick={handleEdit}>
                                    <EditIcon />
                                </Button>
                                {props.uploadDialogOpen
                                    ? null
                                    : <Button onClick={handleDelete}>
                                        <DeleteIcon />
                                    </Button>}
                            </>}
                        <IconButton aria-label="close" size="small" onClick={props.handleClose}>
                            <CloseIcon />
                        </IconButton>
                    </div>
                </div>
                <div className="preview_div">
                    {((props.value && props.value.file && props.value.file.IPFS_hash) ||
                    (url)) &&
                (type === 'video' || type === 'audio')
                        ? <div className="video_content">
                            <VideoPlayer
                                poster={mediaReference(poster)}
                                type={url.includes('.m3u8') ? 'hls' : null}
                                url={url.includes('.m3u8') ? url : mediaReference(url)}
                            />
                        </div>
                        : (type === 'document' || type === 'text')
                            ? <iframe className="pdf_view" src={mediaReference(url)} title={mediaReference(url)}/>
                            : type === 'image'
                                ? <ImageOnLoad cdn={cdn} preview={poster} src={url}/>
                                : <ImageOnLoad src={poster || url}/>}
                </div>
            </DialogContent>
        </Dialog>
    );
};

PreviewDialog.propTypes = {
    deleteAsset: PropTypes.func.isRequired,
    fetch: PropTypes.func.isRequired,
    from: PropTypes.string.isRequired,
    handleClose: PropTypes.func.isRequired,
    hideUploadFilesDialog: PropTypes.func.isRequired,
    lang: PropTypes.string.isRequired,
    mediaNodeDetails: PropTypes.object.isRequired,
    open: PropTypes.bool.isRequired,
    setActiveStep: PropTypes.func.isRequired,
    setAssetUpload: PropTypes.func.isRequired,
    setBulkMint: PropTypes.func.isRequired,
    setLibraryTabValue: PropTypes.func.isRequired,
    streamDetails: PropTypes.object.isRequired,
    uploadDialogOpen: PropTypes.bool.isRequired,
    value: PropTypes.object.isRequired,
    assetsTotal: PropTypes.number,
    data: PropTypes.object,
    router: PropTypes.shape({
        navigate: PropTypes.func.isRequired,
    }),
};

const stateToProps = (state) => {
    return {
        assetsTotal: state.library.assets.total,
        open: state.createAssets.previewDialog.open,
        value: state.createAssets.previewDialog.value,
        from: state.createAssets.previewDialog.from,
        data: state.createAssets.previewDialog.data,
        lang: state.language,
        uploadDialogOpen: state.createAssets.new.uploadFilesDialog,

        mediaNodeDetails: state.mediaNode.mediaNodeDetails.value,
        streamDetails: state.mediaNode.liveStream.streamDetails.value,
    };
};

const actionToProps = {
    deleteAsset,
    fetch: fetchAssets,
    handleClose: hidePreviewDialog,
    hideUploadFilesDialog,
    setActiveStep,
    setAssetUpload,
    setBulkMint,
    setLibraryTabValue,
};

export default withRouter(connect(stateToProps, actionToProps)(PreviewDialog));
